// extracted by mini-css-extract-plugin
export default {"triangleUp":"Triangle_triangleUp__tp4KZ","innerTriangle":"Triangle_innerTriangle__C8d-D"};